import { useMediaQuery, useTheme } from "@mui/material";

/**
 * Returns `true` when the viewport is below the MUI `sm` breakpoint (mobile).
 * Wraps `theme.breakpoints.down("sm")`.
 */
export const useIsMobile = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
};

/**
 * Returns `true` when the viewport is between the MUI `sm` and `lg`
 * breakpoints (tablet range, inclusive of `sm`, exclusive of `lg`).
 * Wraps `theme.breakpoints.between("sm", "lg")`.
 */
export const useIsTablet = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.between("sm", "lg"));
};

/**
 * Returns `true` when the viewport is at or above the MUI `lg` breakpoint
 * (desktop). Wraps `theme.breakpoints.up("lg")`.
 */
export const useIsDesktop = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up("lg"));
};

/**
 * Returns `true` when the viewport is below the MUI `md` breakpoint
 * (mobile + small tablets). Wraps `theme.breakpoints.down("md")`. Use this
 * for layouts that flip between a compact and a roomy variant at the
 * tablet/desktop boundary (e.g. dialog `fullScreen`, thumbnail sizing).
 */
export const useIsBelowDesktop = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("md"));
};
